import { ApolloError, useQuery } from '@apollo/client'
import { COMPANIES_MANAGER_OF_OR_RESPONSIBLE_OF } from '../Queries'
import {
  FindCompaniesAndCountriesByManagerOrResponsibleQuery,
  FindCompaniesAndCountriesByManagerOrResponsibleQueryVariables,
} from '../../../types'

export default (
  businessPartnerVisibility: boolean,
): { data: FindCompaniesAndCountriesByManagerOrResponsibleQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<
    FindCompaniesAndCountriesByManagerOrResponsibleQuery,
    FindCompaniesAndCountriesByManagerOrResponsibleQueryVariables
  >(COMPANIES_MANAGER_OF_OR_RESPONSIBLE_OF, {
    variables: { businessPartnerVisibility },
  })

  return { data, error, loading }
}
